// cian-builder-disable:data-name
import clsx from 'clsx';
import { type FC, type ReactNode } from 'react';

import { EarlyAccessBannerContainer } from '../../containers/EarlyAccessBannerContainer';
import { type TListingLayoutGridType } from '../../types/gridType';
import { CardListLayout } from '../CardListLayout';
import { SkeletonCardList } from '../SkeletonCardList/SkeletonCardList';

import styles from './ListingLayout.css';

type ListingLayoutProps = {
  navigation: ReactNode;
  cards: ReactNode;
  similarCards: ReactNode;
  isFetching: boolean;
  isNarrow: boolean;
  pagination: ReactNode;
  seo: ReactNode;
  noCardsDump: ReactNode;
  gridType?: TListingLayoutGridType;
};

export const ListingLayout: FC<ListingLayoutProps> = ({
  navigation,
  cards,
  noCardsDump,
  pagination,
  seo,
  isNarrow,
  isFetching,
  similarCards,
  gridType = 'oneColumn',
}) => {
  return (
    <>
      <div className={clsx(styles['listing-header'], { [styles['listing-header-narrow']]: isNarrow })}>
        {navigation}
        {seo}
      </div>

      <div className={styles['listing-banner']}>
        <EarlyAccessBannerContainer />
      </div>

      <div className={styles['listing-cards']}>
        {isFetching && (
          <CardListLayout gridType={gridType} isNarrow={isNarrow}>
            <SkeletonCardList isTop of={4} />
          </CardListLayout>
        )}

        {cards && (
          <CardListLayout
            className={isFetching ? styles['listing-cards__cards_hidden'] : undefined}
            dataTestId="listing.cards"
            gridType={gridType}
            isNarrow={isNarrow}
          >
            {cards}
          </CardListLayout>
        )}

        {!isFetching && !cards && noCardsDump}
      </div>

      <div className={styles['listing-pagination']}>{pagination}</div>

      {similarCards && <div className={styles['listing-similar-cards']}>{similarCards}</div>}
    </>
  );
};
